module.exports = __webpack_public_path__ + "img/False-Colour-Optical.18f795d2.png";